import { render, staticRenderFns } from "./IconMotorcycle.vue?vue&type=template&id=afda21e8"
import script from "./IconMotorcycle.vue?vue&type=script&lang=js"
export * from "./IconMotorcycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports